import { useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";

interface ComplianceDialogProps {
  onProceed: () => void;
}

const ComplianceDialog = ({ onProceed }: ComplianceDialogProps) => {
  const heading = useRef<HTMLHeadingElement>(null);

  return (
    <Dialog
      open
      fullWidth
      maxWidth="md"
      scroll="paper"
      disableEscapeKeyDown
      aria-labelledby="compliance-title"
      TransitionProps={{ onEntered: () => heading.current?.focus() }}
      PaperProps={{ sx: { m: { xs: 2, sm: 4 }, width: "100%" } }}
    >
      <DialogTitle id="compliance-title" ref={heading} tabIndex={-1}>
        Terms of Use
      </DialogTitle>
      <DialogContent dividers sx={{ "& p:last-child": { mb: 0 } }}>
        <Typography paragraph>
          The results presented by this service represent processing of data in
          accordance with Section 15 &amp; Schedule 2 part 1 paragraph 2 of the
          Data Protection Act 2018, in that it is considered necessary for the
          detection and prevention of a criminal offence. The results provided
          by this Service are only indicators of potential fraudulent claims and
          as such all claims highlighted will require further investigation in
          order to validate the potential fraud risk. We caution against making
          any presumption of any dishonesty on the part of any persons or
          companies named and accept no liability in relation to or arising from
          any such allegation made as a result of reliance upon the current
          Service. Do not proceed if you are an unauthorised user. Attempts to
          use this Service in an unauthorised manner to alter, destroy or damage
          data may breach the Computer Misuse Act.
        </Typography>
        <Typography paragraph>
          Please be aware that the activity of users of any Keoghs&apos;
          applications, including this website, can be logged and audited for
          compliance with our security and usage policies.
        </Typography>
        <Typography paragraph>
          This website uses cookies to determine if you are logged in or not. No
          personal data is retained. By continuing to access this website you
          are agreeing to our use of cookies in this way.
        </Typography>
        <Typography paragraph>
          Please see our{" "}
          <Link
            href="http://www.keoghs.co.uk/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Notice
          </Link>{" "}
          for further information about how we utilise personal data for
          delivery of this service.
        </Typography>
        <Typography paragraph>
          By proceeding in to this service you agree to and will be bound by the
          above terms. For further information please contact Keoghs LLP.
          Contact details are on our website:{" "}
          <Link
            href="http://www.keoghs.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.keoghs.co.uk
          </Link>
        </Typography>
        <Typography paragraph>
          Alternatively, email the Support Team:{" "}
          <Link
            href="mailto:DTection@keoghs.co.uk"
            sx={{ overflowWrap: "anywhere" }}
          >
            DTection@keoghs.co.uk
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="contained" onClick={onProceed}>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComplianceDialog;
